import { Box, Card, Grid, IconButton, Typography, Breadcrumbs, Link, CircularProgress, ToggleButton, ToggleButtonGroup } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { fileServices } from './fileServices';
import FolderImage from '../../../assets/images/folder.png';
import FolderContent from './FolderContent';
import { ArrowBack, NavigateNext, ViewModule, ViewList } from '@mui/icons-material';
import { FolderItem } from './FileItems';

const FileManager = () => {
  const [folderList, setFolderList] = useState([]);
  const [folderLoading, setFolderLoading] = useState(false);
  const [currentPath, setCurrentPath] = useState(null);
  const [pathHistory, setPathHistory] = useState([]);
  const [viewMode, setViewMode] = useState('grid');
  
  const fetchFolderList = async () => {
    setFolderLoading(true);
    try {
      const response = await fileServices.fetchAllAwsFolders();
      if(response.success == '1'){
        setFolderList(response.data.folders);
      }
    } finally {
      setFolderLoading(false);
    }
  }
  useEffect(()=>{
    fetchFolderList();
  },[])

  const handleFolderClick = (folder) => {
    setPathHistory([...pathHistory, folder]);
    setCurrentPath(folder);
  }

  const handleBreadcrumbClick = (index) => {
    if (index === -1) {
      setCurrentPath(null);
      setPathHistory([]);
    } else {
      const newHistory = pathHistory.slice(0, index + 1);
      setPathHistory(newHistory);
      setCurrentPath(newHistory[newHistory.length - 1]);
    }
  }

  const handleBack = () => {
    if (pathHistory.length > 1) {
      const newHistory = pathHistory.slice(0, -1);
      setPathHistory(newHistory);
      setCurrentPath(newHistory[newHistory.length - 1]);
    } else {
      setCurrentPath(null);
      setPathHistory([]);
    }
  }

  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode);
    }
  }

  const renderBreadcrumbs = () => {
    const crumbs = [{ name: 'Root', index: -1 }];
    pathHistory.forEach((folder, idx) => {
      const folderName = folder.split('/').pop();
      crumbs.push({ name: folderName, index: idx });
    });
    return crumbs;
  }

  return (
    <Card sx={{height:'80vh',overflowY:'auto'}}>
      <Grid container>
        { currentPath ? 
          <Box sx={{width:'100%'}}>
            <Box sx={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0.5rem 1rem',borderBottom:'1px solid #eee'}}>
              <Box sx={{display:'flex',alignItems:'center',gap:1}}>
                <IconButton size='small' onClick={handleBack}>
                  <ArrowBack fontSize='1rem' />
                </IconButton>
                <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ '& .MuiTypography-root': { fontSize: '0.85rem' } }}>
                  {renderBreadcrumbs().map((crumb, idx) => (
                    <Link
                      key={idx}
                      component="button"
                      variant="body1"
                      underline="hover"
                      color="inherit"
                      onClick={() => handleBreadcrumbClick(crumb.index)}
                      sx={{ cursor: 'pointer', fontWeight: idx === pathHistory.length ? 600 : 400 }}
                    >
                      {crumb.name}
                    </Link>
                  ))}
                </Breadcrumbs>
              </Box>
              <ToggleButtonGroup
                value={viewMode}
                exclusive
                onChange={handleViewModeChange}
                size="small"
              >
                <ToggleButton value="grid">
                  <ViewModule fontSize="small" />
                </ToggleButton>
                <ToggleButton value="list">
                  <ViewList fontSize="small" />
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <FolderContent folder={currentPath} setCurrentPath={setCurrentPath} setPathHistory={setPathHistory} pathHistory={pathHistory} viewMode={viewMode} />
          </Box>
        :
          folderLoading ? 
            <Grid item xs={12} sx={{display:'flex',justifyContent:'center',alignItems:'center',height:'200px'}}>
              <CircularProgress />
            </Grid>
          :
          folderList && folderList.length > 0 ? folderList.map((folder,index)=>(
            <Grid item xs={3} sm={2} md={1} key={index}>
              <FolderItem folder={folder} onDoubleClick={() => handleFolderClick(folder)} />
            </Grid>
          )) : 
            <Grid item xs={12}>
              <Typography variant='h6' align='center'>No folders found</Typography>
            </Grid>
        }
      </Grid>
    </Card>
  )
}

export default FileManager
